module.exports = __webpack_public_path__ + "img/27_88.371f1584.png";